import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PaymentRedirectComponent } from './pages/payment-redirect/payment-redirect.component';
import { SeoLandingComponent } from './pages/seo-landing/seo-landing.component';

const landing = (
  path: string,
  slug: string,
  sections: string[],
): Routes[number] => ({
  path,
  component: SeoLandingComponent,
  data: { slug, sections },
});

const routes: Routes = [
  { path: '', component: HomeComponent },
  landing('gap-fakturowy', 'gapFakturowy', ['whatIsGap', 'benefits', 'faq']),
  landing('gap-casco', 'gapCasco', ['whatIsGap', 'benefits', 'faq']),
  landing('gap-flex', 'gapFlex', ['whatIsGap', 'benefits', 'faq']),
  landing('gap-leasing', 'gapLeasing', ['forWho', 'whenToBuy', 'faq']),
  landing('gap-dla-firm', 'gapDlaFirm', ['forWho', 'faq']),
  landing('dla-jakich-pojazdow', 'dlaJakichPojazdow', ['vehicles', 'faq']),
  { path: 'payment-redirect', component: PaymentRedirectComponent },
  {
    path: 'apk',
    loadChildren: () =>
      import('./pages/apk/apk.module').then((m) => m.ApkModule),
  },
  {
    path: 'cta',
    loadChildren: () =>
      import('./pages/cta/cta.module').then((m) => m.CtaModule),
  },
  {
    path: 'new-policy',
    loadChildren: () =>
      import('./pages/policy-creator/policy-creator.module').then(
        (m) => m.PolicyCreatorModule,
      ),
  },
  {
    path: 'new-warranty',
    loadChildren: () =>
      import('./pages/warranty-creator/warranty-creator.module').then(
        (m) => m.WarrantyCreatorModule,
      ),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      onSameUrlNavigation: 'reload',
      enableTracing: false,
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
